module.exports = __webpack_public_path__ + "img/img_cx3.f3ee6f05.jpg";